export default "__VITE_ASSET__pE5hYg91__"